import type {WadObserver} from "~/types/types";

export default defineNuxtPlugin((nuxtApp) => {
    let trackingObserver: IntersectionObserver | undefined;
    let observer: IntersectionObserver | undefined;

    const trackingObserverOptions: IntersectionObserverInit = {
        threshold: 0.4,
    };

    const observerOptions: IntersectionObserverInit = {
        threshold: 0.4,
    };

    const trackEntityView = (entries: IntersectionObserverEntry[], obs: IntersectionObserver): void => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if ((entry.target as any).__vue__) {
                    (entry.target as any).__vue__.$emit('wadIsIntersecting');
                } else {
                    entry.target.dispatchEvent(new CustomEvent('wadIsIntersecting'));
                }
                obs.unobserve(entry.target);
            }
        });
    };

    const fireObserverEvents = (entries: IntersectionObserverEntry[], obs: IntersectionObserver): void => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if ((entry.target as any).__vue__) {
                    (entry.target as any).__vue__.$emit('wadIsIntersecting');
                } else {
                    entry.target.dispatchEvent(new CustomEvent('wadIsIntersecting'));
                }
            } else {
                if ((entry.target as any).__vue__) {
                    (entry.target as any).__vue__.$emit('wadIsNotIntersecting');
                } else {
                    entry.target.dispatchEvent(new CustomEvent('wadIsNotIntersecting'));
                }
            }
        });
    };

    const initTrackingObserver = (): void => {
        trackingObserver = new IntersectionObserver(trackEntityView, trackingObserverOptions);
    };

    const initObserver = (): void => {
        observer = new IntersectionObserver(fireObserverEvents, observerOptions);
    };

    const wadObserver: WadObserver = {
        observeElement: (el: Element): void => {
            if (!trackingObserver) {
                initTrackingObserver();
            }
            trackingObserver?.observe(el);
        },
        startObserving: (el: Element): void => {
            if (!observer) {
                initObserver();
            }
            observer?.observe(el);
        },
        stopObserving: (el: Element): void => {
            observer?.unobserve(el);
        },
    };

    nuxtApp.provide('wadObserver', wadObserver as WadObserver);
});
